// extracted by mini-css-extract-plugin
export default {"courseList":"CourseListPage_courseList__llYWB","emptyList":"CourseListPage_emptyList__BrHfc","count":"CourseListPage_count__Q1XiF"};